(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["drop-rail-controls"] && !Shopify.designMode) return;
  try {
    function initializeDropRails(root) {
    root.querySelectorAll('[data-rail-controls]').forEach(controls => {
      if (controls.dataset.ready) return;
      const track = document.getElementById(controls.dataset.railControls);
      if (!track) return;
      controls.dataset.ready = 'true';
      const previous = controls.querySelector('[data-rail-step="-1"]');
      const next = controls.querySelector('[data-rail-step="1"]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const rtl = getComputedStyle(track).direction === 'rtl';
      const refresh = () => {
        const limit = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);
        controls.hidden = limit < 4;
        previous.disabled = position < 4;
        next.disabled = position >= limit - 4;
      };
      const move = step => {
        const card = track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = card.getBoundingClientRect().width + gap;
        track.scrollBy({ left: step * distance * (rtl ? -1 : 1), behavior: reduced.matches ? 'instant' : 'smooth' });
      };
      controls.querySelectorAll('[data-rail-step]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.railStep))));
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') track.scrollTo({ left:event.key === 'Home' ? 0 : track.scrollWidth * (rtl ? -1 : 1), behavior:reduced.matches ? 'instant' : 'smooth' });
        else move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
      });
      track.addEventListener('scroll', refresh, { passive:true });
      const observer = new ResizeObserver(refresh);
      observer.observe(track);
      if (track.firstElementChild) observer.observe(track.firstElementChild);
      const cleanup = event => {
        if (!event.target.contains(track)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', cleanup);
      };
      document.addEventListener('shopify:section:unload', cleanup);
      refresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeDropRails(document), { once:true });
  else initializeDropRails(document);
  document.addEventListener('shopify:section:load', event => initializeDropRails(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pc-preview"] && !Shopify.designMode) return;
  try {
    function initPCPreviews(root){
 root.querySelectorAll('[data-pc-preview]').forEach(gallery=>{
  if(gallery.dataset.ready)return;
  const template=gallery.querySelector('[data-pc-source]');
  const screen=gallery.querySelector('.pc-screen');
  if(!template||!screen)return;
  const sources=[...template.content.querySelectorAll('img')];
  const buttons=[...gallery.querySelectorAll('[data-pc-step]')];
  if(!sources.length)return;
  gallery.dataset.ready='true';let current=0;let busy=false;
  const copyImage=(image,source)=>{['sizes','srcset','src','alt','width','height'].forEach(key=>{if(source.hasAttribute(key))image.setAttribute(key,source.getAttribute(key));});};
  buttons.forEach(button=>{
   button.disabled=sources.length<2;
   button.addEventListener('click',async event=>{
    event.preventDefault();event.stopPropagation();
    if(busy||sources.length<2)return;
    busy=true;gallery.setAttribute('aria-busy','true');
    const next=(current+Number(button.dataset.pcStep)+sources.length)%sources.length;
    const slots=[screen,...gallery.querySelectorAll('.pc-thumb')];
    const incoming=slots.map((_,i)=>{const image=new Image();image.loading='eager';image.decoding='async';copyImage(image,sources[(next+i)%sources.length]);return image;});
    let transitions=[];
    try{
     await Promise.all(incoming.map(image=>image.decode()));
     if(!gallery.isConnected)return;
     const direction=Number(button.dataset.pcStep);
     const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
     slots.forEach((slot,i)=>{
      const previous=slot.firstElementChild;const image=incoming[i];
      image.style.cssText='position:absolute;inset:0';slot.append(image);
      if(!reduced){
       const timing={duration:460,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'};
       const distance=i===0?28:12;
       transitions.push(image.animate([{opacity:0,transform:`translateX(${direction*distance}px)`},{opacity:1,transform:'translateX(0)'}],timing));
       if(previous)transitions.push(previous.animate([{opacity:1,transform:'translateX(0)'},{opacity:0,transform:`translateX(${-direction*distance}px)`}],timing));
      }
     });
     await Promise.all(transitions.map(animation=>animation.finished));
     slots.forEach((slot,i)=>{incoming[i].style.cssText='';slot.replaceChildren(incoming[i]);});
     current=next;
     gallery.querySelector('[data-pc-position]').textContent=`${current+1} / ${sources.length}`;
    }catch{
     incoming.forEach(image=>image.remove());
    }finally{
     transitions.forEach(animation=>animation.cancel());busy=false;gallery.removeAttribute('aria-busy');
    }
   });
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initPCPreviews(document),{once:true});else initPCPreviews(document);
document.addEventListener('shopify:section:load',e=>initPCPreviews(e.target));
  } catch(e) { console.error(e); }
})();

})();
